// extracted by mini-css-extract-plugin
module.exports =  {"sectionList":"TeamElementsList-module_sectionList_de5a7","imageLabel":"TeamElementsList-module_imageLabel_db1c9"};